import { createContext, ReactNode, useContext } from 'react';
import { useAnimatedBackground } from '../hooks/useAnimatedBackground';

type BackgroundContextValue = {
  isAnimated: boolean;
  toggleAnimated: () => void;
};

const BackgroundContext = createContext<BackgroundContextValue | null>(null);

export function BackgroundProvider({ children }: { children: ReactNode }) {
  const value = useAnimatedBackground();
  return <BackgroundContext.Provider value={value}>{children}</BackgroundContext.Provider>;
}

export function useBackgroundContext(): BackgroundContextValue {
  const ctx = useContext(BackgroundContext);
  if (!ctx) throw new Error('useBackgroundContext must be used within BackgroundProvider');
  return ctx;
}
